import React from 'react'

import './Marker.scss'
import marker from './images/marker.png'

const Marker = () => {
  return (
    <div className='Marker'>
      <img src={marker} />
    </div>
  )
}
Marker.displayName = 'MapMarker'

export default Marker



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/shared/components/Map/components/Marker/Marker.js